export enum DafesSegment {
  Main = 'main',
  Pro = 'pro',
  // Museum = 'museum',
  // Art = 'art',
  Shop = 'shop'
}

export interface SegmentConfig {
  id: string;
  url: string;
  organizationId: string;
}

export const SEGMENTS_CONFIG: Record<DafesSegment, SegmentConfig> = {
  [DafesSegment.Main]: {
    id: DafesSegment.Main,
    url: 'https://dafes.net',
    organizationId: 'cf74a3b99b11457a89e81ce4a5c07408',
  },
  [DafesSegment.Pro]: {
    id: DafesSegment.Pro,
    url: 'https://pro.dafes.net',
    organizationId: 'cf74a3b99b11457a89e81ce4a5c07408',
  },
  // [DafesSegment.Museum]: {
  //   id: DafesSegment.Museum,
  //   url: 'https://museum.dafes.net',
  //   organizationId: '349cc292e6454c3595651dc4b3c4898a',
  // },
  // [DafesSegment.Art]: {
  //   id: DafesSegment.Art,
  //   url: 'https://art.dafes.net',
  //   organizationId: '349cc292e6454c3595651dc4b3c4898a',
  // },
  [DafesSegment.Shop]: {
    id: DafesSegment.Shop,
    url: 'https://shop.dafes.net',
    organizationId: '56042d998b964775af1814d076136d3a',
  },
};

export const getSegmentFromPath = (pathname: string): DafesSegment | null => {
  // if (pathname.startsWith('/art')) return DafesSegment.Art;
  if (pathname.startsWith('/brands')) return DafesSegment.Shop;
  if (
    pathname === '/' ||
    pathname.startsWith('/design') ||
    pathname.startsWith('/competencies') ||
    pathname.startsWith('/tags') ||
    pathname.startsWith('/awards') ||
    pathname.startsWith('/') ||
    pathname.startsWith('/museum')
  ) {
    return DafesSegment.Main;
  }
  return null;
};

export const getSegmentFromContext = (context: string): DafesSegment | null => {
  // if (context === 'dafes-design') return DafesSegment.Main;
  // if (context === 'dafes-art') return DafesSegment.Art;
  return null;
};
export enum DafesSegment {
  Main = 'main',
  Pro = 'pro',
  // Museum = 'museum',
  // Art = 'art',
  Shop = 'shop'
}

export interface SegmentConfig {
  id: string;
  url: string;
  organizationId: string;
}

export const SEGMENTS_CONFIG: Record<DafesSegment, SegmentConfig> = {
  [DafesSegment.Main]: {
    id: DafesSegment.Main,
    url: 'https://dafes.net',
    organizationId: 'cf74a3b99b11457a89e81ce4a5c07408',
  },
  [DafesSegment.Pro]: {
    id: DafesSegment.Pro,
    url: 'https://pro.dafes.net',
    organizationId: 'cf74a3b99b11457a89e81ce4a5c07408',
  },
  // [DafesSegment.Museum]: {
  //   id: DafesSegment.Museum,
  //   url: 'https://museum.dafes.net',
  //   organizationId: '349cc292e6454c3595651dc4b3c4898a',
  // },
  // [DafesSegment.Art]: {
  //   id: DafesSegment.Art,
  //   url: 'https://art.dafes.net',
  //   organizationId: '349cc292e6454c3595651dc4b3c4898a',
  // },
  [DafesSegment.Shop]: {
    id: DafesSegment.Shop,
    url: 'https://shop.dafes.net',
    organizationId: '56042d998b964775af1814d076136d3a',
  },
};

export const getSegmentFromPath = (pathname: string): DafesSegment | null => {
  // if (pathname.startsWith('/art')) return DafesSegment.Art;
  if (pathname.startsWith('/brands')) return DafesSegment.Shop;
  if (
    pathname === '/' ||
    pathname.startsWith('/design') ||
    pathname.startsWith('/competencies') ||
    pathname.startsWith('/tags') ||
    pathname.startsWith('/awards') ||
    pathname.startsWith('/') ||
    pathname.startsWith('/museum')
  ) {
    return DafesSegment.Main;
  }
  return null;
};

export const getSegmentFromContext = (context: string): DafesSegment | null => {
  // if (context === 'dafes-design') return DafesSegment.Main;
  // if (context === 'dafes-art') return DafesSegment.Art;
  return null;
};
